import {createApolloClient, getGraphqlApiEndpointServerCloudEndpoint} from '@/framework/client/apollo-core';
import {
    CurrentCustomerDocument,
    LoginCustomerByUsernameAndPasswordDocument,
    LoginWithPhoneAndOtpDocument,
    RefreshTokenDocument,
} from '@/framework/gql/auth.graphql';
import {ApolloQueryResult} from '@apollo/client';
import {CustomerToken, LoginDevice} from '@/__generated__/__types__';

export const loginCustomerByUserAndPassword = async (
    email: string,
    password: string,
    device: LoginDevice,
): Promise<CustomerToken> => {
    const apolloClient = createApolloClient({ignoreToken: true});
    const result = await apolloClient.mutate({
        mutation: LoginCustomerByUsernameAndPasswordDocument,
        variables: {
            phoneNumber: email,
            password,
            device,
        },
        context: {
            uri: getGraphqlApiEndpointServerCloudEndpoint(),
        },
    });

    if (result.data?.loginCustomerByUsernameAndPassword) {
        return result.data?.loginCustomerByUsernameAndPassword;
    }
    const errors: string[] = [];
    result.errors?.map(err => {
        errors.push(err.message);
    });
    throw new Error(errors.join(', '));
};

export interface CurrentCustomerProfile {
    __typename?: 'Customer';
    phone_number: string;
    firstname?: string | null;
    lastname?: string | null;
    middlename?: string | null;
    email?: string | null;
}

export const getCurrentCustomer = async (token: string): Promise<CurrentCustomerProfile> => {
    const apolloClient = createApolloClient({accessToken: token});
    const result: ApolloQueryResult<{customer: CurrentCustomerProfile}> = await apolloClient.query({
        query: CurrentCustomerDocument,
        context: {
            uri: getGraphqlApiEndpointServerCloudEndpoint(),
        },
    });

    if (result.data?.customer) {
        return result.data.customer;
    }
    const errors: string[] = [];
    result.errors?.map(err => {
        errors.push(err.message);
    });
    throw new Error(errors.join(', '));
};

export const loginWithPhoneAndOtp = async (
    phoneNumber: string,
    otp: string,
    secret: string,
    sign: string,
    device: LoginDevice,
): Promise<CustomerToken> => {
    const apolloClient = createApolloClient({ignoreToken: true});
    try {
        const result = await apolloClient.mutate({
            mutation: LoginWithPhoneAndOtpDocument,
            variables: {
                phoneNumber,
                otp,
                secret,
                sign,
                device,
            },
            errorPolicy: 'all',
            context: {
                uri: getGraphqlApiEndpointServerCloudEndpoint(),
            },
        });

        if (result.data?.loginWithPhoneAndOtp) {
            return result.data?.loginWithPhoneAndOtp;
        }
        const errors: string[] = [];
        result.errors?.map(err => {
            errors.push(err.message);
        });
        throw new Error(errors.join(', '));
    } catch (e) {
        throw e;
    }
};

export const refreshToken = async (refreshToken: string): Promise<CustomerToken> => {
    const apolloClient = createApolloClient({ignoreToken: true});
    const result = await apolloClient.mutate({
        mutation: RefreshTokenDocument,
        variables: {
            refreshToken,
        },
        context: {
            uri: getGraphqlApiEndpointServerCloudEndpoint(),
        },
    });

    if (result.data?.refreshToken) {
        return result.data.refreshToken;
    }

    const errors: string[] = [];
    result.errors?.map(err => {
        errors.push(err.message);
    });
    throw new Error(errors.join(', '));
};
